import type { ProblemDomain } from '..'

export const ANSWER_TYPE: Record<ProblemDomain.ScoringResult, ProblemDomain.ScoringResult> = {
  CORRECT: 'CORRECT',
  WRONG: 'WRONG',
  UNKNOWN: 'UNKNOWN',
  NONE: 'NONE',
  RESTRICTED: 'RESTRICTED',
} as const
